import { setLoadAllCallback } from './set-load-all-callback/set-load-all-callback.js';
import { scrollAnimataion } from './scroll-animataion/scroll-animataion.js';
import { markerSet } from './marker-set/marker-set.js';
import { fadeJudge } from './to-top-btn-fade/to-top-btn-fade.js';


// ===========================================
// メインビジュアル
// ===========================================
function mainVisialAnimation() {
  let scroll = $(window).scrollTop(),
      maxScaleScroll = $('.mainVisualCaption').offset().top + $('.mainVisualCaption').height(),
      value,
      bgFadeInPoint,
      bgFadeOutPoint,
      ttlFadeInPoint,
      endPoint;

  if( scroll < maxScaleScroll ) {
    setTimeout(function () {
      $('.mainVisualImageWrapper').addClass('mainVisualImageWrapper--slideIn');
    }, 1000);

    setTimeout(function () {
      $('.mainVisualImageWrapper').addClass('mainVisualImageWrapper--larger');
    }, 1200);

    setTimeout(function () {
      $('.mainVisual__logo').addClass('mainVisual__logo--fadeIn');
    }, 1900);
  } else {
    $('.mainVisualImageWrapper').addClass('mainVisualImageWrapper--animationEnd');
    $('.mainVisual__logo').addClass('mainVisual__logo--animationEnd');
  }

  function scrollSet() {
    scroll = $(window).scrollTop();
    maxScaleScroll = $('.mainVisualCaption').offset().top + $('.mainVisualCaption').height();
    bgFadeInPoint = $('.mainVisual__logo').offset().top;
    bgFadeOutPoint = $('.mainVisualCaption').offset().top + $('.mainVisualCaption').height();
    ttlFadeInPoint = bgFadeOutPoint;
    endPoint = $('.mainVisual').height() - $(window).height();

    if( scroll >= bgFadeInPoint && scroll < bgFadeOutPoint ) {
      $('.mainVisualCaptionBack').addClass('mainVisualCaptionBack--fadeIn');
    } else {
      $('.mainVisualCaptionBack').removeClass('mainVisualCaptionBack--fadeIn');
    }

    if( scroll >= ttlFadeInPoint ) {
      $('.mainVisual__ttl').addClass('mainVisual__ttl--fadeIn');
    } else {
      $('.mainVisual__ttl').removeClass('mainVisual__ttl--fadeIn');
    }

    if( scroll >= ttlFadeInPoint + 800 ) {
      $(".t-pageHeader").addClass("t-pageHeader--on");
      $(".t-pageHeaderDummy").addClass("t-pageHeaderDummy--off");
      $('.mvScrollWrapper').addClass('mvScrollWrapper--fadeOut');
    } else {
      $(".t-pageHeader").removeClass("t-pageHeader--on");
      $(".t-pageHeaderDummy").removeClass("t-pageHeaderDummy--off");
      $('.mvScrollWrapper').removeClass('mvScrollWrapper--fadeOut');
    }

    if( scroll >= endPoint ) {
      $('.mainVisualImageWrapper').addClass('mainVisualImageWrapper--absolute');
      $('.mainVisual__ttlWrapperInner').addClass('mainVisual__ttlWrapperInner--absolute');
      $('.mvLoadingWrapper').addClass('mvLoadingWrapper--absolute');
      $('.mvScrollWrapper').addClass('mvScrollWrapper--absolute');
      $('.mvInfoWrapper').addClass('mvInfoWrapper--absolute');
    } else {
      $('.mainVisualImageWrapper').removeClass('mainVisualImageWrapper--absolute');
      $('.mainVisual__ttlWrapperInner').removeClass('mainVisual__ttlWrapperInner--absolute');
      $('.mvLoadingWrapper').removeClass('mvLoadingWrapper--absolute');
      $('.mvScrollWrapper').removeClass('mvScrollWrapper--absolute');
      $('.mvInfoWrapper').removeClass('mvInfoWrapper--absolute');
    }
  }

  scrollSet();
  $(window).on('scroll resize', function(){
    scrollSet();
  });

  $('.mvScroll__txt').on('click', function(){
    let position = $('.mainVisualCaption').offset().top + $('.mainVisualCaption').height() + $(window).height() / 3 + 100;

    $("html, body").animate({ scrollTop: position }, 100, "swing");
    return false;
  });
}

let kvLoading = false;
setLoadAllCallback(
  mvImages,
  function(elems) {
    setTimeout(function(){
      $('.mvLoadingWrapper').addClass('mvLoadingWrapper--fadeOut');
      $('.mvScrollWrapper').addClass('mvScrollWrapper--fadeIn');
      mainVisialAnimation();
      kvLoading = true;
    }, 100);
  }
);

setTimeout(function(){
  if( kvLoading === false ) {
    $('.mvLoadingWrapper').addClass('mvLoadingWrapper--fadeOut');
    $('.mvScrollWrapper').addClass('mvScrollWrapper--fadeIn');
    mainVisialAnimation();
  }
}, 5000);


// ===========================================
// ヘッダーのスクロール時のインタラクション
// ===========================================
$(function () {
  let scroll = $(window).scrollTop();

  function headerSet() {
    scroll = $(window).scrollTop();

    if( scroll > $('.mainVisual').height() ) {
      $(".t-pageHeaderDummy").addClass("t-pageHeaderDummy--color");
    } else {
      $(".t-pageHeaderDummy").removeClass("t-pageHeaderDummy--color");
    }
  }

  headerSet();

  $(window).on('scroll', function(){
    headerSet();
  });
});


// ===========================================
// スクロールガイド
// ===========================================
$(function () {
  let delayTime = 0;

  $('.mvLoadingTxt__item').each(function(n){
    delayTime = delayTime + (.01 * n);

    $(this).css({ transitionDelay: delayTime + 's' });
  });

  function txtAnimation() {
    $('.mvLoading__icon').addClass('mvLoading__icon--moving');
    $('.mvLoading__txt').addClass('mvLoading__txt--phase1');

    setTimeout(function(){
      $('.mvLoading__txt').removeClass('mvLoading__txt--phase1');
      $('.mvLoading__txt').addClass('mvLoading__txt--phase2');

      setTimeout(function(){
        $('.mvLoading__icon').removeClass('mvLoading__icon--moving');
        $('.mvLoading__txt').removeClass('mvLoading__txt--phase2');
        $('.mvLoading__txt').addClass('mvLoading__txt--phase3');

        setTimeout(function(){
          $('.mvLoading__txt').removeClass('mvLoading__txt--phase3');
          txtAnimation();
        }, delayTime * 1000 + 200);
      }, delayTime * 1000 + 800);
    }, delayTime * 1000 + 200);
  }
  txtAnimation();
});


// ===========================================
// トピックスエリア
// ===========================================
$(function () {
  $('.topicsSlider').each(function(){
    const slider = $(this),
          nav = slider.parent().find('.topicsSliderNav');
    let slideNum = 3,
        beforeWidth = $(window).width();

    slider.slick({
      autoplay: true,
      appendArrows: nav,
      slidesToShow: 3,
      dots: true,
      autoplaySpeed: 6000,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
});


// ===========================================
// スクロールアニメーションのオプション
// ===========================================
scrollAnimataion({
  className: "beyondArea",
  triggerPoint: 200,
});

scrollAnimataion({
  className: "campaignArea",
  triggerPoint: 200,
});

scrollAnimataion({
  className: "goodsArea",
  triggerPoint: 200,
});

scrollAnimataion({
  className: "eventArea",
  triggerPoint: 200,
});

scrollAnimataion({
  className: "specialArea",
  triggerPoint: 0,
});

scrollAnimataion({
  className: "specialBlock__item",
  triggerPoint: 200,
});


// ===========================================
// 中見出しのインタラクション
// ===========================================
$(function () {
  markerSet( $('.campaignArea') );

  $(window).on('scroll', function(){
    markerSet( $('.campaignArea') );
  });

  markerSet( $('.goodsArea') );

  $(window).on('scroll', function(){
    markerSet( $('.goodsArea') );
  });

  markerSet( $('.eventArea') );

  $(window).on('scroll', function(){
    markerSet( $('.eventArea') );
  });

  markerSet( $('.specialArea') );

  $(window).on('scroll', function(){
    markerSet( $('.specialArea') );
  });

  function markerBeyondSet( area ) {
    const ttl = area.find('.beyondHead__ttl'),
          txt = area.find('.beyondHead__txt');

    let scroll = $(window).scrollTop();

    if( area.offset().top < scroll + $(window).height() - 200 ) {
      ttl.addClass('beyondHead__ttl--markerOn');

      setTimeout(function () {
        ttl.addClass('beyondHead__ttl--markerOff');
        ttl.addClass('beyondHead__ttl--gTxtOn');

        setTimeout(function () {
          ttl.addClass('beyondHead__ttl--gTxtOff');
        }, 200);
      }, 300);

      setTimeout(function () {
        txt.addClass('beyondHead__txt--markerOn');

        setTimeout(function () {
          txt.addClass('beyondHead__txt--markerOff');
          txt.addClass('beyondHead__txt--gTxtOn');

          setTimeout(function () {
            txt.addClass('beyondHead__txt--gTxtOff');
          }, 200);
        }, 300);
      }, 300);
    }
  }

  markerBeyondSet( $('.beyondArea') );

  $(window).on('scroll', function(){
    markerBeyondSet( $('.beyondArea') );
  });

  function markerSpecialSet( area ) {
    const icon = area.find('.specialHead__icon'),
          ttl = area.find('.specialHead__ttl'),
          txt = area.find('.specialHead__txt');
    let scroll = $(window).scrollTop();

    if( area.offset().top < scroll + $(window).height() - 200 ) {
      icon.addClass('specialHead__icon--markerOn');

      setTimeout(function () {
        ttl.addClass('specialHead__ttl--markerOn');

        setTimeout(function () {
          icon.addClass('specialHead__icon--markerOff');
          ttl.addClass('specialHead__ttl--markerOff');
          ttl.addClass('specialHead__ttl--gTxtOn');

          setTimeout(function () {
            ttl.addClass('specialHead__ttl--gTxtOff');
          }, 200);
        }, 300);

        setTimeout(function () {
          txt.addClass('specialHead__txt--markerOn');

          setTimeout(function () {
            txt.addClass('specialHead__txt--markerOff');
            txt.addClass('specialHead__txt--gTxtOn');

            setTimeout(function () {
              txt.addClass('specialHead__txt--gTxtOff');
            }, 200);
          }, 300);
        }, 300);
      }, 400);

      if( area.find('.c-blockHeadTxtMobile--special').length ) {
        const txtMobile = area.find('.c-blockHeadTxtMobile');

        setTimeout(function () {
          txtMobile.addClass('c-blockHeadTxtMobile--markerOn');

          setTimeout(function () {
            txtMobile.addClass('c-blockHeadTxtMobile--markerOff');
            txtMobile.addClass('c-blockHeadTxtMobile--gTxtOn');

            setTimeout(function () {
              txtMobile.addClass('c-blockHeadTxtMobile--gTxtOff');
            }, 200);
          }, 300);
        }, 1100);
      }
    }
  }

  markerSpecialSet( $('.specialBlock__item:nth-child(1)') );

  $(window).on('scroll', function(){
    markerSpecialSet( $('.specialBlock__item:nth-child(1)') );
  });

  markerSpecialSet( $('.specialBlock__item:nth-child(2)') );

  $(window).on('scroll', function(){
    markerSpecialSet( $('.specialBlock__item:nth-child(2)') );
  });
});


// ===========================================
// MVのお知らせのテキストのモーション
// ===========================================
$(function () {
  if( $(".mvInfo").length ) {
    $('.t-pageHeaderDummy').addClass('t-pageHeaderDummy--down');
    $('.t-hamburgerButton').addClass('t-hamburgerButton--down');
  }

  $('.mvInfo').each(function(){
    const parent = $(this);

    function slideSet( parent ) {
      const list = parent.find('.mvInfo__list'),
            child = parent.find('.mvInfo__item');
      let contentWidth = 0,
          num = 0;

      child.each(function(){
        contentWidth = contentWidth + $(this).width();
        num = num + child.html().length * .3
      });

      if( contentWidth > parent.width() ) {
        parent.addClass('mvInfo--move');
      } else {
        parent.removeClass('mvInfo--move');
      }
      list.css({ animationDuration: num + 's' });
    }

    slideSet( parent );

    $(window).on('resize', function(){
      slideSet( parent );
    });
  });
});


// ===========================================
// MVのお知らせのスクロール時のインタラクション
// ===========================================
$(function () {
  let startPos = 0,
      winScrollTop = 0;

  $(window).on('scroll', function(){
    winScrollTop = $(this).scrollTop();

    if ( winScrollTop > 100 ) {
      if( $(".mvInfo").length ) {
        $(".mvInfo").addClass("mvInfo--off");
        $('.t-pageHeaderDummy').removeClass('t-pageHeaderDummy--down');
        $('.t-hamburgerButton').removeClass('t-hamburgerButton--down');
      }
    } else {
      if( $(".mvInfo").length ) {
        $(".mvInfo").removeClass("mvInfo--off");
        $('.t-pageHeaderDummy').addClass('t-pageHeaderDummy--down');
        $('.t-hamburgerButton').addClass('t-hamburgerButton--down');
      }
    }
  });
});


// ===========================================
// キャンペーンエリアのカードのディレイ
// ===========================================
$(function () {
  let delay = 0;

  $('.campaignList__item').each(function( n ){
    delay = .85 + (.05 * n);

    $(this).css({ transitionDelay: delay + 's' });
  });
});


// ===========================================
// ビヨンドリストのレイアウト
// ===========================================
$(function () {
  $('.c-beyondList').each(function(){
    const box = $(this).find('.c-beyondList__box');
    let widthBefore = $(window).width();

    function heightSet() {
      if( $(window).width() > 640 ) {
        box.tile(3);
      } else {
        box.tile(2);
      }
    }
    heightSet();

    $(window).on('resize', function(){
      if( $(window).width() !== widthBefore ) {
        box.css({ height: 'auto' });
        setTimeout(function () {
          heightSet();
        }, 250);
      }
    });
  });
});


// ===========================================
// グッズのスライドショー
// ===========================================
$(function () {
  $('.goodsSlider').each(function(){
    const slider = $(this);

    slider.slick({
      autoplay: true,
      arrows: false,
      slidesToShow: 1,
      dots: true,
      autoplaySpeed: 6000,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });

  $('.goodsSlider__box').tile();

  $(window).on('resize', function(){
    $('.goodsSlider__box').css({ height: 'auto' });
    $('.goodsSlider__box').tile();
  });
});


// ===========================================
// ページ上部へ戻るボタンのインタラクション
// ===========================================
$(function () {
  fadeJudge( $('.t-mainContent') );
});